import {
    browserProfilingIntegration,
    browserTracingIntegration,
    init as browserInit,
    replayIntegration,
} from '@sentry/browser'
import { init as vueInit } from '@sentry/vue'

const OPTIONS = {
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    integrations: [
        browserTracingIntegration(),
        browserProfilingIntegration(),
        replayIntegration({
            // Additional SDK configuration goes in here, for example:
            maskAllText: true,
            blockAllMedia: true,
        }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate:
        import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0,

    // Set profilesSampleRate to 1.0 to profile every transaction.
    // Since profilesSampleRate is relative to tracesSampleRate,
    // the final profiling rate can be computed as tracesSampleRate *
    // profilesSampleRate For example,
    // a tracesSampleRate of 0.5 and
    // profilesSampleRate of 0.5 would results in 25%
    // of transactions being profiled (0.5*0.5=0.25)
    profilesSampleRate:
        import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE || 0,

    // This sets the sample rate to be 10%.
    // You may want this to be 100% while in development and sample at a
    // lower rate in production
    replaysSessionSampleRate:
        import.meta.env.VITE_SENTRY_REPLAYS_SAMPLE_RATE || 0,

    // If the entire session is not sampled, use the below sample rate to
    // sample sessions when an error occurs.
    replaysOnErrorSampleRate:
        import.meta.env.VITE_SENTRY_REPLAYS_ERROR_SAMPLE_RATE || 1.0,
}

export function init (app = null) {
    if (!OPTIONS.dsn) {
        return
    }

    if (app) {
        vueInit({
            app,
            ...OPTIONS,
        })
    } else {
        browserInit(OPTIONS)
    }
}
